export const SITE_NAME = 'ShopGND';
export const BASE_URL = 'https://www.shopgnd.gd';
export const INSTAGRAM_URL = 'https://www.instagram.com/shopgnd.gd/';
export const SEO_KEYWORDS =
  'grenada marketplace, grenada classifieds, shop grenada, buy and sell grenada, grenada online shopping, classifieds grenada';
/** Short brand line (eyebrows, hero, JSON-LD alternateName). */
export const MARKETPLACE_TAGLINE = "Grenada's marketplace";
/** Brand hero slide — tagline under the headline. */
export const MARKETPLACE_HERO_TAGLINE = 'Shop local. Ship island-wide.';
/** Brand hero slide — supporting paragraph (md+). */
export const MARKETPLACE_HERO_SUB =
  "ShopGND is Grenada's online marketplace for local shopping and Grenadian classifieds — vendors, cars, property, jobs, and service pros island-wide.";
/** Full positioning phrase for page titles and H1. */
export const MARKETPLACE_TITLE_PHRASE = "Grenada's Online Marketplace";
/** ~115 chars — fits Semrush/meta guidance while staying descriptive. */
export const DEFAULT_DESCRIPTION =
  `${MARKETPLACE_TAGLINE} and classifieds on ShopGND — shop vendors, property, cars, jobs, and services across the island.`;
export const DEFAULT_OG_IMAGE = `${BASE_URL}/shopgnd-logo.png`;
export const DEFAULT_IMAGE = `${BASE_URL}/shopgnd-icon-512.png`;
/** ~50 chars — primary homepage/document title. */
export const HOME_TITLE = `ShopGND — ${MARKETPLACE_TITLE_PHRASE} & Classifieds`;

export const MES_SLUG = 'modern-electrical-solutions-grenada';
